import { useArchiveFindings } from '../../api/hooks';
import { hasRight, useAuthStore } from '../../auth/store';

const fmt = (v: string) => Number(v).toLocaleString('ru-RU', { maximumFractionDigits: 0 });

/**
 * Приходы на TRON-адреса вне отслеживаемых кошельков (находка `untracked-wallet`
 * аудита архива). Показывается на «Балансах», потому что врёт именно
 * «Позиция»: долг записан, а актив не учтён. Гаснет сам, когда адрес добавят.
 */
export function UntrackedWalletsBanner({ onManageWallets }: { onManageWallets?: () => void }) {
  const canView = hasRight(useAuthStore((s) => s.rights), 'audit.view');
  const { data } = useArchiveFindings({ status: 'open', kind: 'untracked-wallet', limit: 20, enabled: canView });
  const items = (data?.pages ?? []).flatMap((p) => p.items);
  if (items.length === 0) return null;

  return (
    <div className="mb-4 rounded-md border border-[var(--red-border)] bg-[var(--red-bg)] px-3 py-2 text-sm text-danger">
      <div className="font-medium">
        ⚠ {items.length === 1 ? 'Приход на кошелёк' : `Приходы на ${items.length} кошелька`} вне трекинга — «Позиция» занижена
      </div>
      <ul className="mt-1 space-y-0.5">
        {items.map((f) =>
          f.details.kind === 'untracked-wallet' ? (
            <li key={f.id} className="text-xs">
              <span className="break-all font-mono">{f.details.address}</span>: пришло {fmt(f.details.inflow)} USDT ({f.details.ops} опер.
              {f.chatTitle ? `, чат «${f.chatTitle}»` : ''}, последняя {new Date(f.occurredAt).toLocaleDateString('ru-RU')})
            </li>
          ) : null,
        )}
      </ul>
      <div className="mt-1 text-xs">
        Добавьте адрес в кошельки (или проверьте опечатку в команде) — находка закроется сама.
        {onManageWallets && (
          <button type="button" className="ml-2 underline" onClick={onManageWallets}>
            Открыть кошельки →
          </button>
        )}
      </div>
    </div>
  );
}
